import { useCallback } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';

export const useSegmentReset = (analytics: AnalyticsBrowser) => {
  return useCallback(() => {
    analytics.reset();
  }, [analytics]);
};
